import React from 'react';
import { StarIcon } from 'lucide-react';
export function BonusTestimonials() {
  const testimonials = [{
    name: 'Verónica Ledesma',
    city: 'Tucumán',
    text: 'Las plantillas y el calendario anual me ordenaron todo el área. Ahora sé qué tengo que hacer cada mes sin olvidarme de nada.',
    rating: 5
  }, {
    name: 'Mariana Suárez',
    city: 'Santa Fe',
    text: 'Los casos de alto riesgo legal me abrieron los ojos. Evité un problema grave con un despido gracias a esta guía.',
    rating: 5
  }, {
    name: 'Daniela Ríos',
    city: 'Neuquén',
    text: 'Pensé que eran bonos de relleno y resultaron ser lo que más uso. El pack de plantillas vale el precio completo solo.',
    rating: 5
  }];
  return <section className="w-full max-w-4xl mx-auto px-4 pt-12" data-id="element-26" data-mp="1u6omxy5ajpqy">
      <h2 className="text-2xl md:text-3xl font-bold text-center text-gray-900 mb-8" data-id="element-27" data-mp="1g9rw3wp6a8a2">
        Lo que más valoran de los bonos
      </h2>

      <div className="grid md:grid-cols-3 gap-5" data-id="element-28" data-mp="1xww52kgsztsv">
        {testimonials.map((testimonial, index) => <div key={index} className="bg-white rounded-lg p-5 shadow-sm border border-gray-200 hover:shadow-md transition-shadow duration-300" data-id="element-29" data-mp="1sxta5sujf3ym" data-mpi={index}>
            <div className="flex gap-1 mb-3" data-id="element-30" data-mp="27szfedlt6yqw">
              {[...Array(testimonial.rating)].map((_, i) => <StarIcon key={i} className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-31" data-mp="22u4logmazps0" data-mpi={i} />)}
            </div>
            <p className="text-gray-700 mb-4 italic text-sm" data-id="element-32" data-mp="1a94txk701mt6">
              "{testimonial.text}"
            </p>
            <div className="flex items-center gap-2" data-id="element-33" data-mp="1oyaqt1id70xw">
              <div className="w-9 h-9 bg-gradient-to-br from-pink-200 to-purple-200 rounded-full flex items-center justify-center font-bold text-gray-700" data-id="element-34" data-mp="1k4g9g4q8ey1z">
                {testimonial.name.charAt(0)}
              </div>
              <div data-id="element-35" data-mp="rgan5djj5101">
                <p className="font-semibold text-gray-900 text-sm" data-id="element-36" data-mp="repszp14nk2p">
                  {testimonial.name}
                </p>
                <p className="text-xs text-gray-500" data-id="element-37" data-mp="1l6b37dbryqqj">{testimonial.city}</p>
              </div>
            </div>
          </div>)}
      </div>
    </section>;
}